import { render, staticRenderFns } from "./Details.html?vue&type=template&id=c4bb0dd4&scoped=true&"
import script from "./Details.js?vue&type=script&lang=js&"
export * from "./Details.js?vue&type=script&lang=js&"
import style0 from "./Details.scss?vue&type=style&index=0&id=c4bb0dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bb0dd4",
  null
  
)

export default component.exports